export default __webpack_public_path__ + "static/media/mental.7b7e81c0.svg";